import React, { useState } from 'react';
import type { H2HDirectMatch, H2HPlayer } from '../../types/headToHead';

function formatDate(iso: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getFullYear()).slice(-2)}`;
}

interface Props { matches: H2HDirectMatch[]; a: H2HPlayer; b: H2HPlayer; }

export function H2HDirectMatchesList({ matches, a, b }: Props) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ paddingTop: 12 }}>
      <button onClick={() => setOpen((v) => !v)} style={btnHeader}>
        Enfrentamientos directos ({matches.length}) {open ? '▴' : '▾'}
      </button>
      {open && matches.length === 0 && <div style={{ color: '#888', padding: 12, textAlign: 'center' }}>No se enfrentaron directamente en este período.</div>}
      {open && matches.map((m) => (
        <div key={m.matchId} style={item}>
          <div style={{ color: '#aaa', fontSize: 12 }}>{formatDate(m.date)} · {m.location ?? ''}</div>
          <div style={{ color: '#fff', fontSize: 18, fontWeight: 700, margin: '2px 0' }}>{m.score.team1} - {m.score.team2}</div>
          <div style={{ color: '#bbb', fontSize: 13 }}>{a.name}: {m.a.goals}g · {b.name}: {m.b.goals}g</div>
        </div>
      ))}
    </div>
  );
}

const btnHeader: React.CSSProperties = { width: '100%', padding: 10, background: '#1a1a1a', color: '#fff', fontWeight: 700, border: 'none', borderRadius: 8, cursor: 'pointer', textAlign: 'left' };
const item: React.CSSProperties = { borderBottom: '1px solid #222', padding: 12 };
